var Backbone = require("backbone");
var PatientsModel = require("models/patients.model.ts")
require("backbonePaginator");
require("compat");

var PatientsCollection = Backbone.Collection.extend({
  url: '/rest/api/customers/',   // your batch endpoint
  model: PatientsModel,
  save: function () {
    var self = this;

    return Backbone.sync('create', this, {
      url: this.url + 'create',
      data: JSON.stringify(this.toJSON()),
      contentType: 'application/json',
      processData: false,
      success: function (resp) {
        self.trigger("addPaymentSuccess", 'success', resp);
      },
      error: function (model, response) {
        self.trigger("addPaymentSuccess", 'error', model);
      }
    });
  }
});
module.exports = PatientsCollection;